import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {url: String, consent: String, staff: Boolean}
  static targets = ["status"]

  connect() {
    if (this.staffValue) {
      try { this.element.hidden = localStorage.getItem("cookie-notice-seen") === "1" }
      catch { this.element.hidden = false }
    } else this.element.hidden = ["allowed", "denied"].includes(this.consentValue)
  }

  allow() { this.choose("allowed") }

  async choose(choice) {
    if (this.sending) return
    this.sending = true
    try {
      const response = await fetch(this.urlValue, {
        method: "POST", headers: {"Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""},
        body: JSON.stringify({choice})
      })
      if (!response.ok) throw new Error("consent")
      const result = await response.json()
      this.consentValue = result.consent
      document.querySelectorAll("[data-cookie-notice-consent-value]").forEach(element => { element.dataset.cookieNoticeConsentValue = result.consent })
      document.querySelectorAll("[data-analytics-consent-value]").forEach(element => { element.dataset.analyticsConsentValue = result.consent })
      window.dispatchEvent(new CustomEvent("analytics:consent", {detail: result.consent}))
      this.element.hidden = true
      this.statusTarget.textContent = ""
    } catch {
      this.statusTarget.textContent = "Не удалось сохранить подтверждение. Попробуйте ещё раз."
    } finally { this.sending = false }
  }

  dismiss() {
    try { localStorage.setItem("cookie-notice-seen", "1") } catch {}
    this.element.hidden = true
  }

}
